/**
 * @file Contact.js
 * @author Stanley Chen
 * @description Contact component that displays various ways to contact Kiku Japanese
 * Steakhouse including location, hours, phone, email, and social media links
 */

import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Contact.css';

const Contact = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.2 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section className="contact-section" id="contact" ref={ref}>
       <img src="/images/mtnbg.jpg" alt="Background" className="contact-background"/>
      <div className="contact-container">
        <motion.h1 
          className="contact-title"
          initial={{ opacity: 0, y: -20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
          transition={{ duration: 0.6 }}
        >
          CONTACT US
        </motion.h1>
        
        <div className="contact-content">
          <motion.div 
            className="contact-info"
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
          >
            <motion.div className="contact-card" variants={itemVariants}>
              <h2>Location</h2>
              <address>
                417 S Ridge Ave<br />
                Middletown, DE 19709
              </address>
            </motion.div>
            
            <motion.div className="contact-card" variants={itemVariants}>
              <h2>Hours</h2>
              <p className="hours-item">
                <span className="day-span">Fri, Sat</span>
                <span className="time-span">11:30 AM - 10:00 PM</span>
              </p>
              <p className="hours-item">
                <span className="day-span">Sun, Mon, Tue, Wed, Thur</span>
                <span className="time-span">11:30 AM - 9:30 PM</span>
              </p>
            </motion.div>
            
            <motion.div className="contact-card" variants={itemVariants}>
              <h2>Contact us</h2>
              <p>
                <a href="tel:3023788868">(302)-378-8868</a>
              </p>
              <p>
                <a href="mailto:kikusteakhouse8868@gmail.com">kikusteakhouse8868@gmail.com</a>
              </p>
            </motion.div>
            
            <motion.div className="contact-card" variants={itemVariants}>
              <h2>Find us on...</h2>
              <div className="social-links">
                <a href="https://www.facebook.com/kikuMiddletown" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-facebook-f"></i> Facebook page
                </a>
                <a href="https://www.yelp.com/biz/kiku-middletown-2?utm_campaign=www_business_share_popup&utm_medium=copy_link&utm_source=(direct)" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-yelp"></i> Yelp page
                </a>
              </div>
            </motion.div>
          </motion.div>
          
          <motion.div 
            className="contact-image-container"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <img src="/images/gallery/gallery-10.jpg" alt="Kiku Japanese Steakhouse" className="contact-image" />
          </motion.div>
        </div>
        
      </div>
    </section>
  );
};

export default Contact;